import { useState } from "react";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import BjelinButton from "../BjelinButton";
import RoomEditorOverlay from "./overlay";

const RoomEditorButton = ({ title, initialFloor }) => {
  const t = useBjelinTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const _title = title ? title : t("room-editor");

  return (
    <>
      <BjelinButton
        color={"bjelin-green"}
        onClick={() => setIsOpen(true)}
        className=""
      >
        {_title}
      </BjelinButton>
      <RoomEditorOverlay
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        initialFloor={initialFloor}
      />
    </>
  );
};

export default RoomEditorButton;
